var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C10.2333 16 12.125 15.225 13.675 13.675C15.225 12.125 16 10.2333 16 8C16 5.76667 15.225 3.875 13.675 2.325C12.125 0.775 10.2333 0 8 0C6.85 0 5.75 0.2375 4.7 0.7125C3.65 1.1875 2.75 1.86667 2 2.75V0H0V7H7V5H2.8C3.33333 4.06667 4.0625 3.33333 4.9875 2.8C5.9125 2.26667 6.91667 2 8 2C9.66667 2 11.0833 2.58333 12.25 3.75C13.4167 4.91667 14 6.33333 14 8C14 9.66667 13.4167 11.0833 12.25 12.25C11.0833 13.4167 9.66667 14 8 14C6.71667 14 5.55833 13.6333 4.525 12.9C3.49167 12.1667 2.76667 11.2 2.35 10H0.25C0.716666 11.7667 1.66667 13.2083 3.1 14.325C4.53333 15.4417 6.16667 16 8 16Z",
    fill: "#929398"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnLeft);
export default __webpack_public_path__ + "static/media/turnLeft.dfdd037538ba9b551d6deb996a6e8a3a.svg";
export { ForwardRef as ReactComponent };